module.exports = __webpack_public_path__ + "fd0319b0b10c5ad27826120108c493a2.svg";